module.exports = __webpack_public_path__ + "assets/img/34_892.ceb6cce8.jpg";